

<div class="container">
<button class="sign_out" >SIGN UP</button>
<button class="sign_in">SIGN IN</button>
</div>
<style>
.sign_out {
    font-family: 'K2D', sans-serif;
    background: rgba(255, 255, 255, 0);
    border: none;
    display: flex;
    position: absolute;
    top: 2.5rem;
    right: 3rem;
    color: white;
    cursor: pointer;
    text-decoration:underline; 
    font-size: 1rem;
}
.sign_in {
    font-family: 'K2D', sans-serif;
    background: rgba(255, 255, 255, 0);
    width: 6rem;
    height: 2.5rem;
    position: absolute;
    top: 2.5rem;
    right: 8rem;
    border-radius: 10px;
    border: 2px solid white;  
    color: white;
    font-size: 1rem;
    cursor: pointer;
}
</style>